import React, { useState, useEffect, useContext } from "react";

import { AuthContext } from "../../../contexts/auth";

import config from "../../../config";
import ReactLoading from "react-loading";

export default function Transacoes({
  event,
  dataLocacao,
  event_id,
  getEvent,
  vendedores,
  boxes,
  detailsMap,
}) {
  const { user } = useContext(AuthContext);
  const [users, setUsers] = useState(null);
  const [relatorio, setRelatorio] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    vendedor: null,
    forma_de_pagamento: null,
  });

  // ... dentro do componente Reports
  const [tiposPagamentoSelecionados, setTiposPagamentoSelecionados] = useState(
    []
  );

  const [transacoes, setTransacoes] = useState([]);

  const opcoesPagamento = [
    { id: "dinheiro", label: "Dinheiro" },
    { id: "pix", label: "Pix" },
    { id: "cheque", label: "Cheque" },
    { id: "outro", label: "Outro" },
  ];

  const handleCheckboxChange = (id) => {
    setTiposPagamentoSelecionados((prev) =>
      prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id]
    );
    console.log(tiposPagamentoSelecionados);
  };

  async function getRelatorioGeral(
    user,
    event_id,
    vendedor,
    tiposPagamentoSelecionados
  ) {
    try {
      const response = await fetch(
        `${config.urlServer}/event/relatorios/relatorio-geral-pdf`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            email: user.email,
            token: user.token,
            eventid: event_id,
            vendedor,
            tiposPagamentoSelecionados,
          },
        }
      );

      const responseData = await response.json();

      if (response.status !== 200) {
        const errorMessage =
          responseData.msg || "Erro desconhecido ao buscar os eventos";
        throw new Error({ message: errorMessage, status: response.status });
      }

      let locacoes = responseData.locacoes;
      let ingressos_avulsos = responseData.ingressos_avulsos;
      let list_transacoes = responseData.list_transacoes;
      console.log(responseData);
      return { locacoes, ingressos_avulsos, list_transacoes };
      // return responseData;
    } catch (error) {
      console.error(error);
      throw new Error(
        error.message || "Ops, algo deu errado ao gerar relatório!"
      );
    }
  }
  useEffect(() => {
    async function loadRelatorio() {
      try {
        setLoading(true);
        const vendedorFiltro =
          typeof formData.vendedor === "string" ? formData.vendedor : "";

        const data = await getRelatorioGeral(
          user,
          event_id,
          vendedorFiltro,
          tiposPagamentoSelecionados
        );

        console.log(data);

        setTransacoes(data.list_transacoes || []);
      } catch (error) {
        console.error("Erro ao carregar transações:", error);
      } finally {
        setLoading(false);
      }
    }

    loadRelatorio();
  }, [event_id, tiposPagamentoSelecionados]);
  function formatCurrency(value) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value || 0);
  }

  function formatDate(date) {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("pt-BR");
  }

  return (
    <section className="tab-reports-event">
      {loading ? (
        <article
          style={{
            display: "flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            padding: "10%",
          }}
        >
          <ReactLoading
            type="spinningBubbles"
            color="var(--rotary-gold)"
            height={"5%"}
            width={"5%"}
          />
        </article>
      ) : (
        <section className="space-y-6">
          <h3 className="text-lg font-semibold text-gray-800">Transações</h3>
          {/* CARD – FILTROS */}
          <section className="bg-white border border-gray-400 rounded-lg p-4 shadow-sm space-y-4">
            <h4 className="font-medium text-gray-700">Filtros</h4>

            {/* FORMAS DE PAGAMENTO */}
            <div>
              <p className="text-sm text-gray-600 mb-2">
                Filtrar por forma de pagamento
              </p>

              <div className="flex flex-wrap gap-4">
                {opcoesPagamento.map((op) => (
                  <label
                    key={op.id}
                    className="flex items-center gap-2 text-sm text-gray-700"
                  >
                    <input
                      type="checkbox"
                      className="accent-blue-600"
                      checked={tiposPagamentoSelecionados.includes(op.id)}
                      onChange={() => handleCheckboxChange(op.id)}
                    />
                    {op.label}
                  </label>
                ))}
              </div>
            </div>

            {/* VENDEDOR */}
            <div className="flex flex-col sm:flex-row gap-3">
              <select
                name="vendedor"
                value={formData?.vendedor || ""}
                onChange={(e) => {
                  const selectedVendedor = [
                    { email: "semvendedor", nome: "Sem vendedor" },
                    ...vendedores,
                  ].find((item) => item.email === e.target.value);

                  setFormData((prev) => ({
                    ...prev,
                    vendedor:
                      e.target.value === "semvendedor" || e.target.value === ""
                        ? ""
                        : e.target.value,
                  }));
                }}
                className="border border-gray-300 rounded-md px-3 py-2 text-sm"
              >
                <option value="">Todos os vendedores</option>

                <option value="semvendedor">Sem vendedor</option>

                {vendedores.map((v) => (
                  <option key={v.email} value={v.email}>
                    {v.nome}
                  </option>
                ))}
              </select>

              <button
                onClick={() => {
                  // força reload explícito
                  setTiposPagamentoSelecionados([
                    ...tiposPagamentoSelecionados,
                  ]);
                }}
                className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Aplicar filtros
              </button>
            </div>
          </section>
          {transacoes.length === 0 ? (
            <p className="text-sm text-gray-500">
              Nenhuma transação encontrada.
            </p>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full border border-gray-200 rounded-lg">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-4 py-2 text-left text-sm font-medium">
                      Vendedor
                    </th>
                    <th className="px-4 py-2 text-left text-sm font-medium">
                      Comprador
                    </th>
                    <th className="px-4 py-2 text-left text-sm font-medium">
                      Tipo
                    </th>
                    <th className="px-4 py-2 text-left text-sm font-medium">
                      Valor
                    </th>
                    <th className="px-4 py-2 text-left text-sm font-medium">
                      Data Pagamento
                    </th>
                    <th className="px-4 py-2 text-left text-sm font-medium">
                      Observação
                    </th>
                    <th className="px-4 py-2 text-center text-sm font-medium">
                      Comprovante
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {transacoes.map((transacao) => (
                    <tr
                      key={transacao.id}
                      className="border-t hover:bg-gray-50"
                    >
                      <td className="px-4 py-2 text-sm text-gray-700">
                        {transacao.vendedor_nome || "—"}
                      </td>

                      <td className="px-4 py-2 text-sm text-gray-700">
                        {transacao.comprador || "—"}
                      </td>

                      <td className="px-4 py-2 text-sm capitalize">
                        {transacao.tipo}
                      </td>

                      <td className="px-4 py-2 text-sm font-medium">
                        {formatCurrency(transacao.valor)}
                      </td>

                      <td className="px-4 py-2 text-sm">
                        {formatDate(transacao.data_pagamento)}
                      </td>

                      <td className="px-4 py-2 text-sm text-gray-600">
                        {transacao.observacao || "-"}
                      </td>

                      <td className="px-4 py-2 text-center">
                        {transacao.comprovante_url_virtual ? (
                          <a
                            href={transacao.comprovante_url_virtual}
                            target="_blank"
                            rel="noreferrer"
                            className="text-blue-600 hover:underline text-sm"
                          >
                            Visualizar
                          </a>
                        ) : (
                          <span className="text-gray-400 text-sm">—</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      )}
    </section>
  );
}
